/* @flow */

export const IDP_COOKIE_EXPIRY_DAYS = 30;

export const IDP_COMMONID = 'pubcommonid';
export const IDP_LIVERAMP = 'liveramp';
export const IDP_PUBMATIC = 'pubmatic';
export const IDP_PUBLINK = 'publink';
export const IDP_VZM = 'verizon';
export const IDP_33ACROSS = '33across';
export const IDP_FABRICK = 'fabrick';
export const IDP_ID5 = 'id5';

/* User ID Module Keys */
export const USER_ID_CRITEO = 'criteo';
export const USER_ID_PUBCOMMON = 'pubcommon';
export const USER_ID_LIVERAMP = 'liveramp';
export const USER_ID_FABRICK = 'fabrick';
export const USER_ID_VERIZON = 'verizon';
export const USER_ID_UNIFIEDID = 'tdid';
export const USER_ID_PUBLINK = 'publink';
export const USER_ID_LOTAMEPANORAMA = 'lotamepanorama';
export const USER_ID_PARRABLE = 'parrable';
export const USER_ID_ID5 = 'id5';
export const USER_ID_33ACROSS = '33acrossId';
export const USER_ID_GOOGLEPAIRID = 'pairId';

/**
 * prebid UserID keys
 * refer userID/eid.js in prebid codebase. The same is useful for mapping in bidbase
 */
export const PREBID_UID_PUBCOMMON = 'pubcid';
export const PREBID_UID_LIVERAMP = 'idl_env';
export const PREBID_UID_VERIZON = 'connectid';
export const PREBID_UID_CRITEO = 'criteoId';
export const PREBID_UID_FABRICK = 'fabrickId';
export const PREBID_UID_UNIFIEDID = 'tdid';
export const PREBID_UID_PUBPROVIDEDID = 'pubProvidedId';
export const PREBID_UID_LOTAMEPANORAMAID = 'lotamePanoramaId';
export const PREBID_UID_PARRABLEID = 'parrableId';
export const PREBID_UID_PUBLINKID = 'publinkId';
export const PREBID_UID_ID5ID = 'id5Id';
export const PREBID_UID_33ACROSS = '33acrossId';
export const PREBID_UID_GOOGLEPAIRID = 'pairId';
